import { BehaviorSubject } from 'rxjs'

/**
 * This is to allow playback start in blocking scenarios, ie, tvod modal
 */
export const unblockPlayback$ = new BehaviorSubject()
